import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  isModalOpen: false,
  segments: [],
  contacts: [],
  isLoading: false,
  error: null,
  segmentCategoryName: "",
};

// Create the slice
const communicationSlice = createSlice({
  name: "communication",
  initialState,
  reducers: {
    openModal: (state) => {
      state.isModalOpen = true;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
    },
    setSegments: (state, action) => {
      state.segments = action.payload;
    },
    setContacts: (state, action) => {
      state.contacts = action.payload;
    },
    setAllData: (state, action) => {
      state.allData = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setSegmentCategoryName: (state, action) => {
      state.segmentCategoryName = action.payload;
    },
    updateSegmentSuccess: (state, action) => {
      const updatedSegment = action.payload;
      const index = state.segments.findIndex(
        (segment) => segment.id === updatedSegment.id
      );
      if (index !== -1) {
        state.segments[index] = updatedSegment;
      }
    },
    deleteSegmentSuccess: (state, action) => {
      state.segments = state.segments.filter(
        (segment) => segment.id !== action.payload
      );
    },
  },
});

// Export actions
export const {
  openModal,
  closeModal,
  setSegments,
  setContacts,
  setLoading,
  setError,
  setSegmentCategoryName,
  updateSegmentSuccess,
  deleteSegmentSuccess,
  setAllData,
} = communicationSlice.actions;

// Export the reducer
export default communicationSlice.reducer;
